module.exports = __webpack_public_path__ + "img/bg_selection2.5fd719e5.png";